import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockContainer from '../BlockContainer';

import css from './BlockHomeImg.module.css';

const SparkleWine = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M24 12C17.7782 12 12 17.7782 12 24C12 17.7782 6.22183 12 0 12C6.22183 12 12 6.22183 12 0C12 6.22183 17.7782 12 24 12Z" fill="#8C265C"/>
  </svg>
);

const SparkleGreen = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M24 12C17.7782 12 12 17.7782 12 24C12 17.7782 6.22183 12 0 12C6.22183 12 12 6.22183 12 0C12 6.22183 17.7782 12 24 12Z" fill="#2c7859"/>
  </svg>
);

const FieldMedia = props => {
  const { className, media, sizes, options } = props;
  const hasMediaField = hasDataInFields([media], options);
  return hasMediaField ? (
    <div className={classNames(className, css.media)}>
      <Field data={media} sizes={sizes} options={options} />
    </div>
  ) : null;
};

// Per-index config:
// 0 → full pill (top+bottom), no sparkle
// 1 → arch top only, green sparkle LEFT
// 2 → full pill (top+bottom), wine sparkle RIGHT
// 3 → arch top only, no sparkle
const BLOCK_CONFIG = [
  { shape: 'pill',  sparkle: null,    side: null    },
  { shape: 'arch',  sparkle: 'green', side: 'left'  },
  { shape: 'pill',  sparkle: 'wine',  side: 'right' },
  { shape: 'arch',  sparkle: null,    side: null    },
];

const BlockHomeImg = props => {
  const {
    blockId,
    blockIndex,
    className,
    rootClassName,
    mediaClassName,
    textClassName,
    ctaButtonClass,
    title,
    text,
    callToAction,
    media,
    responsiveImageSizes,
    options,
    alignment,
  } = props;

  const config = BLOCK_CONFIG[blockIndex] || BLOCK_CONFIG[3];
  const isPill = config.shape === 'pill';

  const classes = classNames(rootClassName || css.root, className);

  const mediaClasses = classNames(css.media, {
    [css.mediaPill]: isPill,
    [css.mediaArch]: !isPill,
  });

  const hasTextComponentFields = hasDataInFields([title, text, callToAction], options);

  const alignmentClasses = {
    left: css.alignLeft,
    center: css.alignCenter,
    right: css.alignRight,
  };
  const alignmentClass = alignmentClasses[alignment];

  return (
    <BlockContainer id={blockId} className={classes}>
      <div className={css.mediaWrapper}>
        {config.sparkle === 'green' && config.side === 'left' && (
          <span className={classNames(css.sparkle, css.sparkleLeft)}>
            <SparkleGreen />
          </span>
        )}
        {config.sparkle === 'wine' && config.side === 'right' && (
          <span className={classNames(css.sparkle, css.sparkleRight)}>
            <SparkleWine />
          </span>
        )}
        <FieldMedia
          media={media}
          sizes={responsiveImageSizes}
          className={classNames(mediaClassName, mediaClasses)}
          options={options}
        />
      </div>
      {hasTextComponentFields ? (
        <div className={classNames(textClassName, alignmentClass, css.text)}>
          <Field data={title} options={options} />
          <Field data={text} options={options} />
          <Field data={callToAction} className={ctaButtonClass} options={options} />
        </div>
      ) : null}
    </BlockContainer>
  );
};

export default BlockHomeImg;
